// Angular
import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
// 3rd-party
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-field-search-period',
    templateUrl: './field-search-period.component.html',
    styleUrls: ['./field-search-period.component.scss'],
    standalone: false
})
export class FieldSearchPeriodComponent implements OnChanges {
    @Input() codeOptions: any[] = [];
    @Input() code: string = null;
    @Input() from: string = null;
    @Input() until: string = null;
    @Input() placeholder: string = '';
    @Input() allowClear: boolean = true;
    @Output() codeChange = new EventEmitter();
    @Output() fromChange = new EventEmitter();
    @Output() untilChange = new EventEmitter();
    @Output() search = new EventEmitter();

    helper: any = {
        selected: null
    };

    @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => {
            this.closeForm();
        }, 1);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.code && this.from && this.until) this.code = 'range';
        this.setSelected();
    }

    setSelected() {
        if (this.code) {
            this.helper.selected = this.codeOptions.find((item) => {
                return item.value === this.code;
            });
        }
    }

    openForm(popover?: NgbPopover) {
        this.helper.FORM = JSON.parse(
            JSON.stringify({
                code: this.code || 'range',
                from: this.from,
                until: this.until
            })
        );
        this.helper.FORM.popover = popover;
    }

    closeForm() {
        if (!this.helper.FORM) return;
        if (this.helper.FORM.code === 'range') {
            if (this.helper.FORM.from || this.helper.FORM.until) {
                this.codeChange.emit(this.helper.FORM.code);
                this.fromChange.emit(this.helper.FORM.from);
                this.untilChange.emit(this.helper.FORM.until);
            } else {
                this.fromChange.emit(null);
                this.untilChange.emit(null);
            }
        }
        if (this.helper.FORM.code !== 'range') {
            this.helper.FORM.from = null;
            this.helper.FORM.until = null;
            this.codeChange.emit(this.helper.FORM.code);
            this.fromChange.emit(this.helper.FORM.from);
            this.untilChange.emit(this.helper.FORM.until);
        }
        if (this.helper.FORM.popover) this.helper.FORM.popover.close();
        this.helper.FORM = null;
        this.search.emit();
    }

    changeDate() {
        this.helper.reloadingDates = true;
        setTimeout(() => {
            this.helper.reloadingDates = false;
        }, 0);
    }

    clear() {
        if (this.helper.FORM.popover) this.helper.FORM.popover.close();
        this.helper.FORM = null;
        this.codeChange.emit(null);
        this.fromChange.emit(null);
        this.untilChange.emit(null);
        this.search.emit();
    }
}
